/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Actions/ServiceEndpointsActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { ServiceEndpoint, AzureSubscription } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export interface IServiceEndpointItemList {
    data: string[];
    callbackParameters: { [key: string]: string };
    append: boolean;
}

export class ServiceEndpointsActions extends ActionsHubBase {

    public static getKey(): string {
        return "service-endpoints-actions";
    }

    public initialize(instanceId?: string) {
        this._getServiceEndpoints = new Action<ServiceEndpoint[]>();
        this._getAzureSubscriptions = new Action<AzureSubscription[]>();
        this._getAADTenantId = new Action<string>();
        this._getKubernetesClusters = new Action<IServiceEndpointItemList>();
        this._getKubernetesClusterNamespaces = new Action<IServiceEndpointItemList>();
    }

    public get getServiceEndpoints(): Action<ServiceEndpoint[]> {
        return this._getServiceEndpoints;
    }

    public get getAzureSubscriptions(): Action<AzureSubscription[]> {
        return this._getAzureSubscriptions;
    }

    public get getTenantId(): Action<string> {
        return this._getAADTenantId;
    }

    public get getKubernetesClusters(): Action<IServiceEndpointItemList> {
        return this._getKubernetesClusters;
    }

    public get getKubernetesClusterNamespaces(): Action<IServiceEndpointItemList> {
        return this._getKubernetesClusterNamespaces;
    }

    private _getServiceEndpoints: Action<ServiceEndpoint[]>;
    private _getAzureSubscriptions: Action<AzureSubscription[]>;
    private _getAADTenantId: Action<string>;
    private _getKubernetesClusters: Action<IServiceEndpointItemList>;
    private _getKubernetesClusterNamespaces: Action<IServiceEndpointItemList>;
}
